import { useEffect, useState } from 'react'

import useFeatureFlag from 'hooks/useFeatureFlag'

import FilterButton from './FilterButton'
import {
  AdultQuantitySelect,
  ChildQuantitySelect,
  PetQuantitySelect,
} from '../common/QuantitySelect'

const getLabel = (numberOfPeople, pets) => {
  const peopleLabel =
    numberOfPeople > 0
      ? `${numberOfPeople} ${numberOfPeople > 1 ? 'people' : 'person'}`
      : "Who's in"
  if (pets > 0) {
    return `${peopleLabel}, ${pets} ${pets > 1 ? 'pets' : 'pet'}`
  }
  return peopleLabel
}

// eslint-disable-next-line no-unused-vars
const CapacityFilter = ({ values, onChange, valueKey }) => {
  const petFeesEnabled = useFeatureFlag('pet_fees')

  const [adults, setAdults] = useState(values.adults || 0)
  const [children, setChildren] = useState(values.children || 0)
  const [pets, setPets] = useState(values.pets || 0)

  useEffect(() => {
    setAdults(values.adults || 0)
    setChildren(values.children || 0)
    setPets(values.pets || 0)
  }, [values.adults, values.children, values.pets])

  const numberOfPeople = adults + children

  const onApply = () => {
    onChange({
      adults,
      children,
      pets,
      ...(pets > 0 ? { petFriendly: true } : {}),
    })
  }

  const onClear = () => {
    onChange({ adults: null, children: null, pets: 0 })
  }

  const onReset = () => {
    setAdults(values.adults || 0)
    setChildren(values.children || 0)
    setPets(values.pets || 0)
  }

  return (
    <FilterButton
      label={getLabel(numberOfPeople, pets)}
      onApply={onApply}
      onClear={onClear}
      onReset={onReset}
      isActive={
        (values.adults || 0) + (values.children || 0) + (values.pets || 0) > 0
      }
    >
      <AdultQuantitySelect
        value={adults}
        onChange={(nextAdults) => {
          setAdults(nextAdults)
          if (!nextAdults) {
            setChildren(0)
            setPets(0)
          }
        }}
      />

      <ChildQuantitySelect
        value={children}
        onChange={(nextChildren) => {
          setChildren(nextChildren)
          if (nextChildren > 0 && !adults) setAdults(1)
        }}
      />

      {petFeesEnabled && (
        <PetQuantitySelect
          value={pets}
          onChange={(nextPets) => {
            setPets(nextPets)
            if (nextPets > 0 && !adults) setAdults(1)
          }}
        />
      )}
    </FilterButton>
  )
}

export default CapacityFilter
